import { useEffect, useState,useContext } from "react";
import { toast } from "react-toastify";
import { createCustomers, updateCustomers } from "../../../Utility/Api";
import { InputField } from "../../Common/CommonCard";
import { WarehouseContext } from '../../../Utility/UserContext';


export const EditCustomers = ({
  showModal,
  setShowModal,
  fetchCustomers,
  selectedCustomers,
  fetchdata,
  AddorEdit,
}) => {
  const { showLoader, hideLoader,shopItem,UserItem } = useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    name: "",
    contact_email: "",
    phone: "",
    country: "",
    branch: "",
    status: "1",
    additional_details: "",
    shop_id:shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
  });

  const [errors, setErrors] = useState({
    contact_email: "",
    phone: "",
  });
  useEffect(() => {
    setFormData({
      ...formData,
      name: selectedCustomers?.name || "",
      shop_id:shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
      contact_email: selectedCustomers?.contact_email || "",
      phone: selectedCustomers?.phone || "",
      country: selectedCustomers?.country || "",
      branch: selectedCustomers?.branch || "",
      status: selectedCustomers?.status || "1",
      additional_details: selectedCustomers?.additional_details || "",
    });
  }, [selectedCustomers]);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]+$/;
    return phoneRegex.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader()
    const validationErrors = {};

    // if (!formData.contact_email) {
    //   validationErrors.contact_email = "Email is required.";
    // }
    if (!formData.name) {
      validationErrors.name = "Name is required.";
    }
    //  if (!formData.phone.length < 8) {
    //   validationErrors.phone = "Phone number must be at least 8 digits long.";
    // }
    
    if (!formData.country) {
      validationErrors.country = "country is required.";
    }
    // if (!formData.branch) {
    //   validationErrors.branch = "branch  is required.";
    // }
    
    if (Object.keys(validationErrors).length > 0) {  
      setErrors(validationErrors);
      hideLoader()
      return;
    }

    const payload = {
      name: formData.name,
      contact_email: formData.contact_email,
      phone: formData.phone,
      country: formData.country,
      branch: formData.branch,
      additional_details: formData.additional_details,
      shop_id:shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
    };
    console.log("Payload being sent:", payload);

    try {
      if (AddorEdit) {
        await createCustomers(payload);
        hideLoader()
        toast.success("Customers Added successfully");
      } else {
        await updateCustomers(selectedCustomers?.customer_id, payload);
        hideLoader()
        toast.success("Customers Updated successfully");
      }
      setShowModal(false);
      fetchCustomers();
      fetchdata();
    } catch (error) {
      // if(error.response.data.errors?.contact_email.length > 0){
      //   toast.error(error.response.data.errors.contact_email[0])
      // }  

      console.error("Error  data:", error.response?.data.message);
      hideLoader()
      toast.error(error.response?.data.message)
    }
  };

  const handleCancel = () => {
    setShowModal(false);
    handleclear();
    setFormData({
      name: "",
      contact_email: "",
      phone: "",
      country: "",
      branch: "",
      status: "",
      additional_details: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,
      });
      return;
    }

    // Validation for email
    // if (name === "contact_email" && !validateEmail(value)) {
    //   setErrors({ ...errors, contact_email: "Invalid email address" });
    // } else if (name === "contact_email") {
    //   setErrors({ ...errors, contact_email: "" });
    // }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleclear = () => {
    setShowModal(false);
    setErrors({
      contact_email: "",
    });
  };
  

  return (
    <>
      {showModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
                  {selectedCustomers ? "Edit Customers" : "Add Customers"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => handleCancel()}
                ></button>
              </div>
              <div className="modal-body" style={{ fontFamily: "poppins" }}>
                <form onSubmit={handleSubmit}>
                  {InputField('Customers','name','text',formData.name,handleChange,12,null,errors.name)}
                  {/* <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">Customers</label>
                    <div className="col-8">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className="form-control"
                      
                    />
                     {errors.name && (
                    <small className="text-danger mx-2">{errors.name}</small>
                  )}
                    </div>
                  </div> */}
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">Email</label>
                    <div className="col-8">
                      <input
                        type="text"
                        name="contact_email"
                        value={formData.contact_email}
                        onChange={handleChange}
                        className="form-control"
                      />
                      {errors.contact_email && (
                        <small className="text-danger mx-2">
                          {errors.contact_email}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">Phone</label>
                    <div className="col-8">
                    <input
                      type="text"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="form-control"
                      
                    />
                    {errors.phone && (
                    <small className="text-danger">{errors.phone}</small>
                  )}
                    </div>
                  </div>
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">Country</label>
                    <div className="col-8">
                    <input
                      type="text"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="form-control"
                    />
                    {errors.country && (
                    <small className="text-danger">{errors.country}</small>
                  )}
                    </div>
                  </div>
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">Branch</label>
                    <div className="col-8">
                    <input
                      type="text"
                      name="branch"
                      value={formData.branch}
                      onChange={handleChange}
                      className="form-control"
                      
                    />
                    {errors.branch && (
                    <small className="text-danger">{errors.branch}</small>
                  )}
                    </div>
                  </div>
                  <div className="form-group mb-3 d-flex align-items-center">
                    <label className="col-4 text-normal">
                      Additional Details
                    </label>
                    <input
                      type="text"
                      name="additional_details"
                      value={formData.additional_details}
                      onChange={handleChange}
                      className="form-control"
                      
                    />
                  </div>

                  <div className="mt-5">
                    <button
                      type="submit"
                      className="btn btn-success float-end text-normal rounded-1"
                      style={{ fontFamily: "poppins" }}
                    >
                      {selectedCustomers ? "Update Customers" : "Add Customers"}
                    </button>
                    &nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                      onClick={() => handleCancel()}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
